$(document).ready(function(){
//   $('#review-carousel').owlCarousel({
//     center:true,
// 	     margin:30,
// 	     loop:true,
// 		 slideSpeed : 300,
// 		paginationSpeed : 400,
// 		autoplay:true,
// 		nav:false,
// 		pagination:false,  dots: true,
// 		navText: ["<i class='fa fa-angle-left'></i>","<i class='fa fa-angle-right'></i>"],
// 	    responsive:{
// 	        0:{
// 	            items:1
// 	        },
// 	        480:{
// 	            items:1
// 	        },
// 	        700:{
// 	            items:1
// 	        },
// 	        1000:{
// 	            items:3
// 	        },
// 	        1100:{
// 	            items:3
// 	        }
// 	    }
// 	});
  
  $('.main-carousel').flickity({
  // options
  cellAlign: 'left',
  contain: true,
    groupCells: '100%',
    prevNextButtons: false,
    autoPlay: true
   
});
  
  });

/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// setTimeout(function(){
//    $('.button--full[name="checkout"]').attr("disabled","disabled");
//   $('.mini-cart__button-container .button[name="checkout"]' ).removeAttr("disabled");  
// },2000);

//       jQuery(document).on("change",".vtl-at-main-widget .vtl-at-main-widget__input",function(){
//         if ($(this).is(':checked')) {
//           $('.button--full[name="checkout"]').removeAttr("disabled");
//         }
//         else
//         {
//            $('.button--full[name="checkout"]').attr("disabled","disabled");
//         }
//       });

setTimeout(function(){
  
  jQuery(".line-item__meta").each(function(){
    var line_item = $(this).find(".line-item__title").text().trim();
    if(line_item == "Front Line Shipping")
    {
        $("#cinput").attr("checked","checked");
    }
  });
  },1000);
      jQuery(document).on("change","#cinput",function(){
           if ($(this).is(':checked')) {
                
               var quantity = 1;
                quantity = parseInt(quantity);
                var id="45141092925737";
                $.ajax({
                    type: 'POST',
                    url: window.theme.localeRootUrl +'/cart/add.js',
                    dataType: 'json',
                    data: {id:id,quantity:quantity},
                    success: function(){
                        location.href="/cart";
                      
                    }
                });
          }
          else
           {
             var quantity = 0;
                quantity = parseInt(quantity);
                var id="45141092925737";
                $.ajax({
                    type: 'POST',
                    url: window.theme.localeRootUrl +'/cart/change.js',
                    dataType: 'json',
                    data: {id:id,quantity:quantity},
                    success: function(){
                        location.href="/cart";
                      
                    }
                });
           }
           
      });
